module.exports = __webpack_public_path__ + "img/Reconnaissance plantes.ddb556b6.png";